import React, {useEffect, useRef, useState} from "react";
import store from "../../../reducers/createReducers";
import GLOBAL_ACTIONS from "../../../actions/global-actions";
import SvgIcon from "../../../components/svg-icon";
import {useSelector} from "react-redux";
import Loading from "../../../components/loading";
import associateServices from "../../../services";
import {useTranslation} from "react-i18next";
import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import RankIcon from "../../../components/rank-icon";
import moment from "moment/moment";
import confetti from "canvas-confetti";
import stringHelper from "../../../helpers/string-helper";
import AUTHENTICATION_ACTIONS from "../../../actions/authentication-actions";

const WheelPrizeModal = () => {
    const {t, i18n} = useTranslation()
    const currentLanguage = i18n.language; // Get the current language
    const navigate = useNavigate()
    const {activeLanguage} = useSelector(state => state.globalReducer)
    const {user} = useSelector(state => state.authenticationReducer)
    const location = useLocation()
    const [loading, setLoading] = useState(true)
    const [details, setDetails] = useState({})

    console.log('details = ', details)
    const getParams = (key) => {
        const searchParams = new URLSearchParams(location?.search);
        return searchParams.get(key);
    }

    useEffect(() => {
        const prize = getParams('prize')

        if (prize)
            getPrizeDetails(prize)
    }, [location?.search])

    const getPrizeDetails = (prizeID) => {
        associateServices.getWheelPrizeDetail({
            id: prizeID
        }).then(res => {
            setDetails(res?.data)
            setLoading(false)
        })
    }

    useEffect(() => {
        const bdy = document.body
        bdy?.classList?.add('modal-open')

        const mdl = document.getElementById('wheel-prize-modal')
        mdl?.classList?.add('show')

        mdl.style.display = 'block'
        mdl.style.backgroundColor = 'rgba(0,0,0,.7)'
    }, [])
    const [searchParams, setSearchParams] = useSearchParams()

    const handleClose = () => {
        searchParams.delete('modal')
        searchParams.delete('prize')
        setSearchParams(searchParams)
        store.dispatch(GLOBAL_ACTIONS.setModalTypeAction(null))
    }

    const canvasRef = useRef(null);

    const handleClaim = () => {


        setTimeout(() => {
            const myConfetti = confetti.create(canvasRef.current, {
                resize: true,
                useWorker: true,
            });

            myConfetti({
                particleCount: 200,
                spread: 160,
                origin: {y: 0.3},
            });

        }, 500);
    };
    useEffect(() => {

        const interval = setInterval(() => {
            handleClaim()
        }, 1000); // every 15 seconds

        return () => clearInterval(interval);
    }, [details?.prize?.image])


    const [claiming, setClaiming] = useState(false)
    const handleClaimPrize = () => {
        const prizeID = getParams('prize')

        if (!prizeID)
            return false;
        setClaiming(true)

        associateServices.getWheelPrizeClaim({
            id: prizeID
        }).then(res => {
            setClaiming(false)

            if (res?.status !== 200)
                return false

            if (res?.data?.action === 'navigate') {
                handleClose()
                return navigate(location.pathname + res?.data?.path)
            }

            if (res?.data?.action === 'refresh') {


                const handleUserWallets = response => store.dispatch(AUTHENTICATION_ACTIONS.setUserWallets(response?.data || []))
                const getUserWallets = () => associateServices.getWallets({}).then(handleUserWallets)

                getUserWallets().then(r => handleClose())
            }


        })
    }
    return (
        <div
            className="modal fade"
            id="wheel-prize-modal"
            tabIndex={-1}
            aria-labelledby="wheel-prize-modal"
            aria-hidden="true"
            // onClick={handleClose}

        >

            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal__content">

                        <div className="modal__head">
                            <h6 className="modal__title"/>
                            <button
                                className="modal__close"
                                type="button"
                                aria-label="Close"
                                onClick={handleClose}
                            >
                                <SvgIcon id={'x'}/>
                            </button>
                        </div>


                        {
                            loading ? <Loading/> :
                                <div className={'d-flex flex-column align-items-center'}>
                                    <canvas ref={canvasRef} className="gift-confetti-canvas"/>

                                    <h1 className="section__title section__title--head">{t('wheel.congratulations')}</h1>

                                    <span className="chat__user">
                                      <RankIcon icon={details?.customer?.ranki}/>
                                      <button className="chat__name" type="button">
                                        {details?.customer?.is_public ? details?.customer?.username : details?.customer?.masked_username}
                                      </button>
                                    </span>

                                    <div className={"wheel-prize-container"}>
                                        <img alt={details?.prize?.name} className={"wheel-prize-img"}
                                             src={details?.prize?.image}/>

                                        <span className="title">{details?.prize?.name?.toUpperCase()}</span>
                                    </div>

                                    {/*<span>{details?.prize?.name?.toUpperCase()}</span>*/}


                                    {
                                        details?.customer?.id === user?.id ?

                                            claiming ? <Loading/> :
                                                <div className="neon-button" onClick={handleClaimPrize}>

                                                    <span> {t('wheel.claim', 'Claim')}</span>

                                                </div> : null

                                    }
                                    <span className={"text-secondary"}>
                                                {moment.unix(details?.used_at || 0).format('MMMM D, YYYY h:mm A')}
                                    </span>

                                    {/*<GiftBox/>*/}
                                </div>
                        }
                    </div>
                </div>

            </div>
        </div>

    )


}

export default WheelPrizeModal
